import { handleActions } from 'redux-actions'
import {
  garageSetData,
  garageSetServices,
  garageInitSuccess,
  garageInitError
} from './actions'

const getDefaultState = () => ({
  campiObbligatori: [],
  coloreBase: null,
  finestraAppuntamentiDataMax: null,
  finestraAppuntamentiGiorniA: null,
  finestraAppuntamentiGiorniDa: null,
  pdvDescrizione: null,
  pdvIndirizzo: null,
  testoServizio: [],
  isInitialized: false,
  initError: null,
  services: []
})

export const reducer = handleActions(
  {
    [garageSetData]: (state, { payload }) => ({ ...state, ...payload }),
    [garageSetServices]: (state, { payload }) => ({
      ...state,
      services: payload.map(service => ({ ...service }))
    }),
    [garageInitSuccess]: state => ({ ...state, isInitialized: true }),
    [garageInitError]: (state, { payload }) => ({
      ...state,
      initError: payload
    })
  },
  getDefaultState()
)
